import styled from 'styled-components';
import { CarGalleryStyled } from '../CarGalleryStyled';
import { rem } from 'polished';

export const CarGalleryStyledAC = styled(CarGalleryStyled)`
    .button-wrapper {
        button {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            font-family: ${({ theme }) => theme.fonts.fontSecondary};
            font-size: ${({ theme }) => theme.fontSizes.textSubMedium};
            text-transform: uppercase;
            opacity: 0.5;

            &.active {
                color: ${({ theme }) => theme.colors.primary};
                cursor: default;
                opacity: 1;
            }

            &:first-child {
                margin-right: ${rem(20)};
            }
        }
    }
`;
